import * as React from "react";
import LoyaltySignup from "../../shared/LoyaltySignup/LoyaltySignup";
import { ComponentProps } from "src/typings/flexFramework/FlexComponent";

export const LoyaltySignupWrapper: React.FC<ComponentProps> = ({ context }) => {
  return <LoyaltySignup context={context} />;
};

export default LoyaltySignupWrapper;
